module.exports = __webpack_public_path__ + "img/antenne_modules.de4a347f.svg";